export default __webpack_public_path__ + "static/media/RYS_9370.cb169741.jpg";